import request from '@/utils/request'
//获取热门标签
export function GetRmteg(data) {
  return request({
    url: `/html/rm_teg`,
    method: 'get',
    params: data 
  })
}


// WEBPACK FOOTER //
// ./src/api/rm-teg.js